import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import './index.css';
import App from './App';
import LoginPage from './LoginPage';
import LandingPage from './LandingPage';
import CheckoutPage from './CheckoutPage';
import ProfilePage from './ProfilePage';
import HiddenPage from './HiddenPage';
import MesafeliSatisSozlesmesi from './MesafeliSatisSozlesmesi';
import GizlilikSozlesmesi from './GizlilikSozlesmesi';
import TeslimatVeIade from './TeslimatVeIade';
import OrnekVideolar from './OrnekVideolar';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { auth, db } from './firebase';
import { LandingPageProvider } from './contexts/LandingPageContext';

const ProtectedRoute = ({ children }) => {
  const [state, setState] = useState({ checking: true, allowed: false, userData: null });

  useEffect(() => {
    let isMounted = true;
    let unsubscribeAuth = null;
    let unsubscribeFirestore = null;

    unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (!isMounted) return;

      if (!user) {
        // Kullanıcı çıkış yaptı, Firestore listener'ı temizle
        if (unsubscribeFirestore) {
          unsubscribeFirestore();
          unsubscribeFirestore = null;
        }
        setState({ checking: false, allowed: false, userData: null });
        return;
      }

      // Kullanıcı giriş yaptı, Firestore'dan real-time dinle
      const userDocRef = doc(db, 'users', user.uid);
      
      unsubscribeFirestore = onSnapshot(
        userDocRef,
        (docSnapshot) => {
          if (!isMounted) return;

          if (docSnapshot.exists()) {
            const userData = docSnapshot.data();
            setState({ 
              checking: false, 
              allowed: Boolean(userData?.isPremium), 
              userData 
            });
          } else {
            // Document yoksa
            setState({ checking: false, allowed: false, userData: null });
          }
        },
        (error) => {
          console.error('ProtectedRoute Firestore error:', error);
          if (isMounted) {
            setState({ checking: false, allowed: false, userData: null });
          }
        }
      );
    });

    return () => {
      isMounted = false;
      if (unsubscribeAuth) unsubscribeAuth();
      if (unsubscribeFirestore) unsubscribeFirestore();
    };
  }, []);

  if (state.checking) {
    return null
    /*return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        Yükleniyor...
      </div>
    );*/
  }

  if (!state.allowed) {
    return <Navigate to="/login" replace />;
  }

  // userData'yı children'a prop olarak geçir
  return React.cloneElement(children, { userData: state.userData });
};

// ScrollToTop component - Her route değişiminde scroll'u en üste al
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <LandingPageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
            <Route
              path="/lectures"
              element={
                <ProtectedRoute>
                  <App />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<LandingPage />} />
            <Route path="/ornek-videolar" element={<OrnekVideolar />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/mesafeli-satis-sozlesmesi" element={<MesafeliSatisSozlesmesi />} />
            <Route path="/gizlilik-sozlesmesi" element={<GizlilikSozlesmesi />} />
            <Route path="/teslimat-ve-iade" element={<TeslimatVeIade />} />
            <Route path="/roadMapHidden" element={<HiddenPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      </LandingPageProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
